module.exports = __webpack_public_path__ + "static/scale-model-of-byu-museum-of-paleontology-in-provo-utah-88491291d86ed3da4211976315653840.png";